import { Component } from 'react'
import GovActionForm from './views/form'

const defaultState = {
  open: false,
  topic: null,
  formSuccess: {},
  options: [],
  optionValues: [],
  defaultOption: {},
}

const getDefaultOption = (options = []) => (options.length === 1 ? options[0] : {})

export class GovActions extends Component {
  constructor(props) {
    super(props)
    this.state = props.defaultState || defaultState
    this.handleChange = this.handleChange.bind(this)
    this.toggle = this.toggle.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.removeOption = this.handleDone.bind(this)
    this.processOptions = this.processOptions.bind(this)
    this.resetForm = this.resetForm.bind(this)
  }

  componentDidMount() {
    if (this.props.options) {
      this.processOptions(this.props.options)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options) {
      this.processOptions(this.props.options)
    }
  }

  processOptions(options = [], otherValuesForState = {}) {
    const filteredOptions = options.filter(option => option && option.label)

    this.setState({
      options: filteredOptions,
      optionValues: filteredOptions.map(option => option.value),
      defaultOption: getDefaultOption(filteredOptions),
      ...otherValuesForState,
    })
  }

  handleChange(name, value) {
    this.setState({
      [name]: value,
      open: this.state.optionValues.includes(value),
    })
  }

  toggle() {
    this.setState({
      open: !this.state.open,
    })
  }

  handleSuccess(successfulForm, topic = null) {
    this.setState({
      formSuccess: {
        ...this.state.formSuccess,
        ...successfulForm,
      },
      topic: this.state.defaultOption.topic ? this.state.defaultOption.topic : topic,
    })
  }

  handleDone(topic) {
    return () => {
      const { defaultOption, options } = this.state

      const newFormOptions = {
        formSuccess: defaultState.formSuccess,
        open: defaultState.open,
        topic: defaultState.topic,
      }

      // essentially reset the form
      this.processOptions(
        defaultOption.onCompletePreserveAction
          ? options
          : options.filter(option => option.value !== topic),
        newFormOptions
      )
    }
  }

  resetForm() {
    return this.setState({
      open: false,
      topic: null,
    })
  }

  render() {
    let { topic, formSuccess = {}, options, defaultOption, open } = this.state
    const { labelText } = this.props
    if (!topic) topic = defaultOption.value
    const isCompleted = !!formSuccess[topic]
    const completedMessage = isCompleted ? formSuccess[topic] : null
    const currentOption = options.find(option => option.value === topic)
    const actionForm =
      currentOption && (currentOption.actionForm ? currentOption.actionForm : GovActionForm)

    return options.length === 0
      ? null
      : this.props.render(
          {
            open,
            topic,
            toggle: this.toggle,
            onChange: this.handleChange,
            defaultOption,
            currentOption,
            actionForm,
            options,
            handleSuccess: this.handleSuccess,
            isCompleted,
            completedMessage,
            onComplete: this.handleDone(topic),
            resetForm: this.resetForm,
            labelText,
          },
          this.props.children
        )
  }
}

export default GovActions



// WEBPACK FOOTER //
// ./src/ui/gov-actions/container.js